import { Outlet } from 'react-router-dom'

export const LayoutSemLayout = () => {
  return (
    <div className='bg-esforce-black-400 mx-auto my-0 flex h-full w-screen max-w-[635px] flex-col items-center justify-center gap-10'>
      <Outlet />
    </div>
  )
}
